import request from '@/utils/http'

// 查询某类型对象的可以导出的属性, 0:老师 1:老师归档信息 2:学生 3:学生归档信息 6:家长 7:打卡 8:请假 9:招生的学生信息 10:招生家长 11:工程 12:归档工程
function excelFieldFind (type: any) {
  return request({
    url: `excelField/find/${type}`,
    method: 'get'
  })
}

// 某类型对象的模板, 0:老师 2:学生 4:代缴代扣 5:学校信息 9:招生的学生信息 10:招生家长 11:工程 12:归档工程 13:招生(学前) 14:事业年报 15:资金分配 16:负面清单 17:困难人口 18:资助在校学生 19:资助困难学生
function excelFieldTemplate (params: any) {
  return request({
    url: `excelField/template/${params.type}`,
    responseType: 'arraybuffer', // 或者responseType: 'blob'
    xsrfHeaderName: 'authorization',
    method: 'get'
  })
}

export default {
  excelFieldFind,
  excelFieldTemplate
}
